import { z } from 'zod';

export const EXECUTIVE_SUMMARY_VERSION = 1 as const;

export const ExecutiveSummaryDataPointSchema = z.object({
  key: z.string(),
  value: z.union([z.string(), z.number()]),
  unit: z.string().optional(),
  emphasis: z.enum(['primary', 'secondary']).optional(),
});

export type ExecutiveSummaryDataPoint = z.infer<typeof ExecutiveSummaryDataPointSchema>;

export const ExecutiveSummaryCitationSchema = z.object({
  number: z.number().int().positive(),
  source_type: z.enum(['card', 'chart']),
  source_id: z.string().min(1),
  source_title: z.string().min(1),
  source_subtitle: z.string().optional(),
  data_points: z.array(ExecutiveSummaryDataPointSchema),
  truncated_count: z.number().int().nonnegative().optional(),
  anchor: z.string().min(1),
  note: z.string().optional(),
});

export type ExecutiveSummaryCitation = z.infer<typeof ExecutiveSummaryCitationSchema>;

export const ExecutiveSummaryPayloadSchema = z.object({
  version: z.literal(EXECUTIVE_SUMMARY_VERSION),
  generated_at: z.string(),
  model: z.string().min(1),
  body_markdown: z.string().min(1),
  citations: z.array(ExecutiveSummaryCitationSchema),
});

export type ExecutiveSummaryPayload = z.infer<typeof ExecutiveSummaryPayloadSchema>;

export const ExecutiveSummaryStatusSchema = z.enum(['ready', 'stale', 'generating']);
export type ExecutiveSummaryStatus = z.infer<typeof ExecutiveSummaryStatusSchema>;
